/* import __COLOCATED_TEMPLATE__ from './unassign-unsnoozed-setting.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';
import type IntlService from 'ember-intl/services/intl';

type WhenAwayMode = 'when_away_only' | 'when_away_and_reassign';

interface DropdownItem {
  text: string;
  value: string;
}

interface Args {
  unassignUnsnoozedAtCapacityEnabled: boolean;
  unassignUnsnoozedAtCapacityUpdate(value: boolean): void;
  unassignUnsnoozedWhenAwayEnabled: boolean;
  unassignUnsnoozedWhenAwayAndReassignEnabled: boolean;
  unassignUnsnoozedWhenAwayUpdate(value: boolean, mode: WhenAwayMode): void;
}

interface Signature {
  Args: Args;
  Element: never;
}

export default class UnassignUnsnoozedSetting extends Component<Signature> {
  @service declare appService: AppService;
  @service declare intl: IntlService;

  @action
  toggleUnassignUnsnoozedAtCapacity() {
    let newValue = !this.args.unassignUnsnoozedAtCapacityEnabled;
    this.args.unassignUnsnoozedAtCapacityUpdate(newValue);
  }

  get whenAwayMasterEnabled(): boolean {
    return (
      this.args.unassignUnsnoozedWhenAwayEnabled ||
      this.args.unassignUnsnoozedWhenAwayAndReassignEnabled
    );
  }

  get selectedWhenAwayMode(): WhenAwayMode {
    if (this.args.unassignUnsnoozedWhenAwayAndReassignEnabled) {
      return 'when_away_and_reassign';
    }
    return 'when_away_only';
  }

  get hasSubOptions(): boolean {
    return this.appService.app.canUseFeature('inbox-unassign-unsnooze-when-away-and-reassign');
  }

  get whenAwayDropdownItems(): DropdownItem[] {
    return [
      {
        text: this.intl.t(
          'settings.workload-management.unassign-unsnoozed.when-away-dropdown-away',
        ),
        value: 'when_away_only',
      },
      {
        text: this.intl.t(
          'settings.workload-management.unassign-unsnoozed.when-away-dropdown-away-and-reassign',
        ),
        value: 'when_away_and_reassign',
      },
    ];
  }

  @action
  toggleWhenAway() {
    if (this.whenAwayMasterEnabled) {
      this.args.unassignUnsnoozedWhenAwayUpdate(false, this.selectedWhenAwayMode);
    } else {
      this.args.unassignUnsnoozedWhenAwayUpdate(true, 'when_away_only');
    }
  }

  @action
  selectWhenAwayMode(mode: WhenAwayMode) {
    this.args.unassignUnsnoozedWhenAwayUpdate(true, mode);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox::WorkloadManagement::UnassignUnsnoozedSetting': typeof UnassignUnsnoozedSetting;
    'inbox/workload-management/unassign-unsnoozed-setting': typeof UnassignUnsnoozedSetting;
  }
}
